import styled from "styled-components";

const Input = styled.input`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  border: 1px solid var(--color-grey-300);
  background-color: var(--color-grey-0);
  border-radius: var(--border-radius-sm);
  box-shadow: var(--shadow-sm);
  padding: 0.8rem 0.4em;
  width: 15em;
`;

export default Input;
